import { useEffect } from 'react';
export const useClickOutside = _ref => {
  let {
    isOpen,
    setDropdownState,
    wrapperRef,
    showList
  } = _ref;
  useEffect(() => {
    const handleMouseLeave = event => {
      var _a;
      const target = event.target;
      if (isOpen && !((_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(target)) && !showList) {
        setDropdownState("closed" /* DropdownStates.CLOSED */);
      }
    };
    window.addEventListener('mousedown', handleMouseLeave);
    return () => {
      window.removeEventListener('mousedown', handleMouseLeave);
    };
  }, [isOpen, setDropdownState, showList, wrapperRef]);
};